// 公募基金累计收益
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import Model, { valueWithArray } from 'ducker-model';
import chartTool from '../utils/chart';

// 收益点
const pointProperty = {
  date: String,
  value: String,
  type: String,
};

const sylKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'SYL',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'syl-point',
  },
};

const SYLModel = new Model(pointProperty, sylKeyFromPropertyName);

const seKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'SE',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'se-point',
  },
};

const SEModel = new Model(pointProperty, seKeyFromPropertyName);

const sameTypeAvgKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'avgSE',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'sameTypeAvg-point',
  },
};

const SameTypeAvgModel = new Model(pointProperty, sameTypeAvgKeyFromPropertyName);

const sameKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'availableForPurchaseAvgSe',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'sameTypeAvgCanBuy-point',
  },
};

const SameTypeAvgCanBuyModel = new Model(pointProperty, sameKeyFromPropertyName);

// Model
const property = {
  sylPointList: valueWithArray(Object),
  sePointList: valueWithArray(Object),
  sameTypeAvgPointList: valueWithArray(Object),
  sameTypeAvgCanBuyPointList: valueWithArray(Object),
  extraInfo: Object,
};

const replacedKeyFromPropertyName = {
  sylPointList: {
    property: 'data',
    computed: (data) => SYLModel.objectArrayWithKeyValuesArray(data),
  },
  sePointList: {
    property: 'data',
    computed: (data) => SEModel.objectArrayWithKeyValuesArray(data),
  },
  sameTypeAvgPointList: {
    property: 'data',
    computed: (data) => SameTypeAvgModel.objectArrayWithKeyValuesArray(data),
  },
  sameTypeAvgCanBuyPointList: {
    property: 'data',
    computed: (data) => SameTypeAvgCanBuyModel.objectArrayWithKeyValuesArray(data),
  },
  extraInfo: {
    property: 'expansion',
    computed: (expansion) => {
      const aboutAccResponses = expansion?.aboutAccResponses || []; // 额外数据
      const changeInfo = expansion?.changeInfo || [];
      const maxReturn = expansion?.MAXRETRA || '';
      return {
        indexInfo: aboutAccResponses?.[aboutAccResponses.length - 1] || {},
        changePoints: chartTool.handleChangeInfo(changeInfo),
        maxReturn: chartTool.handleChartMaxReturn(changeInfo, maxReturn),
      };
    },
  },
};

export default new Model(property, replacedKeyFromPropertyName);
